import React, { Component } from 'react';

import BaseModal from '../BaseModal';
import Spinner from 'components/Spinner';
import EditAddressForm from './EditAddressForm';

class EditAddressModal extends Component {
  render() {
    const { address, loading, saveAddress } = this.props;
    return (
      <BaseModal
        title="Edit Address"
        confirmBtnText=""
        cancelBtnText=""
        {...this.props}
      >
        <EditAddressForm initialValues={address} onSubmit={saveAddress} />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default EditAddressModal;
